import React, { useEffect, useState } from "react";

interface Props {
  credits: number;
  onClick?: () => void;
}

const FloatingUpgradeBanner: React.FC<Props> = ({ credits, onClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show when credits are exactly 10 or 5
    if (credits === 10 || credits === 5) {
      // Check if we've already shown the banner for this credit threshold
      const shownKey = `upgrade_banner_shown_${credits}`;
      const hasBeenShown = localStorage.getItem(shownKey) === 'true';
      
      if (!hasBeenShown) {
        setVisible(true);
        // Mark as shown for this threshold
        localStorage.setItem(shownKey, 'true');
      }
    } else {
      setVisible(false);
    }
  }, [credits]);

  const handleClose = () => {
    setVisible(false);
    // Reset localStorage values so banner will show again when user refills credits
    localStorage.removeItem('upgrade_banner_shown_10');
    localStorage.removeItem('upgrade_banner_shown_5');
  };

  const handleUpgradeClick = () => {
    // Reset localStorage values when user clicks upgrade link
    localStorage.removeItem('upgrade_banner_shown_10');
    localStorage.removeItem('upgrade_banner_shown_5');
    // Call the provided onClick function
    if (onClick) {
      onClick();
    }
  };

  if (!visible) return null;

  const styles = {
    container: {
      position: "absolute" as const,
      bottom: "100%",
      right: "calc(15% - 60px)",
      backgroundColor: "var(--theme-surface-strong, #ffffff)",
      color: "var(--theme-text, #333)",
      border: "1px solid var(--theme-border, #e0e0e0)",
      padding: "12px 16px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px var(--theme-shadow, rgba(0, 0, 0, 0.08))",
      display: "flex",
      alignItems: "center",
      maxWidth: "240px",
      fontSize: "14px",
      zIndex: 9999,
      animation: "slideUpFadeIn 0.4s ease",
      transition: "transform 0.3s ease, opacity 0.3s ease",
      transform: "translateY(0)",
      opacity: 1,
    },
    text: {
      flex: 1,
    },
    link: {
      marginLeft: "4px",
      fontWeight: 600,
      color: "var(--theme-primary-action, #0077ff)",
      cursor: "pointer",
      textDecoration: "none",
    },
    closeButton: {
      background: "none",
      border: "none",
      fontSize: "16px",
      marginLeft: "10px",
      color: "var(--theme-muted, #888)",
      cursor: "pointer",
    },
    
  };

  return (
    <div style={styles.container}>
      <div style={styles.text}>
        🔓 Only {credits} credits left –
        <span style={styles.link} onClick={handleUpgradeClick}>
          {" "}
          Get unlimited access
        </span>
      </div>
      <button style={styles.closeButton} onClick={handleClose}>
        ✕
      </button>
    </div>
  );
};

export default FloatingUpgradeBanner;
